export const load = () => ({
	title: 'Block Outdoor Air Pollution',
	h1: 'Keep Out Pollen & Pollutants With Window Inserts',
	description:
		'Indow inserts block pollen and pollutants by creating an airseal in your windows.',
	showTitle: true,
});
